import {
	OnInit,
	Component,
	Inject,
	Optional,
	ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogClose,
} from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion } from '@angular/material/expansion';

@Component({
	selector: 'app-funded-details-modal',
	templateUrl: './funded-details-modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./funded-details-modal.component.scss'],
	imports: [
		CdkDrag,
		CdkDragHandle,
		MatIconButton,
		MatDialogClose,
		MatIcon,
		MatAccordion,
		ReactiveFormsModule,
		FormlyModule,
	],
})
export class FundedDetailsModalComponent implements OnInit {
	constructor(
		private dialogRef: MatDialogRef<FundedDetailsModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) private data: any
	) {}

	// Formly configuration
	protected form = new FormGroup({});
	protected model: any = {};
	protected fields: FormlyFieldConfig[] = [
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Opportunity_Status',
					type: 'formly-label',
					props: {
						label: 'Payment Frequency',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Term_of_Loan',
					type: 'formly-label',
					props: {
						label: 'Term of Loan (Months)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Term_of_Loan_Years',
					type: 'formly-label',
					props: {
						label: 'Term of Loan (Years)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Tertiary_Annual_Income',
					type: 'formly-label',
					props: {
						label: 'Scheduled Payments (CU Fee Included)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Total_Ob',
					type: 'formly-label',
					props: {
						label: 'Total Obligation Entire Term(formula)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Referral_Amount',
					type: 'formly-label',
					props: {
						label: 'Total Cost of Borrowing',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'LPP_Included',
					type: 'formly-label',
					props: {
						label: 'LPP Included?',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Co_Applicant_LPP',
					type: 'formly-label',
					props: {
						label: 'Co-Applicant LPP included?',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Credit_Upgrader_included',
					type: 'formly-label',
					props: {
						label: 'Credit Upgrader included?',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'CU_Fee',
					type: 'formly-label',
					props: {
						label: 'CU Fee',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Sch_Payment_Plus_CU_Fee',
					type: 'formly-label',
					props: {
						label: 'Sch. Payment (No CU Fee)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Loan_Date',
					type: 'formly-label',
					props: {
						label: 'Loan Date',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Date_Ordered',
					type: 'formly-label',
					props: {
						label: 'First Payment Date',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Date_Received',
					type: 'formly-label',
					props: {
						label: 'Last Payment Date',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Interest_APR1',
					type: 'formly-label',
					props: {
						label: 'Interest (APR)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Fee_Est',
					type: 'formly-label',
					props: {
						label: 'Setup Fee',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Click_n_loan',
					type: 'formly-label',
					props: {
						label: 'Click n loan',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Deferral',
					type: 'formly-label',
					props: {
						label: 'Deferral',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Loan_Agreement_Created_by',
					type: 'formly-label',
					props: {
						label: 'Loan Agreement Created by',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'NSF_Fee',
					type: 'formly-label',
					props: {
						label: 'NSF Fee',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Credit_Owl_Course',
					type: 'formly-label',
					props: {
						label: 'Credit Owl Course?',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Grand_Total_Credit_Owl_Fees',
					type: 'formly-label',
					props: {
						label: 'Grand Total Credit Owl Fees',
					},
				},
			],
		},
	];

	ngOnInit() {
		this.model = {
			Opportunity_Status: this.data.application.Opportunity_Status,
			Term_of_Loan: this.data.application.Term_of_Loan,
			Term_of_Loan_Years: this.data.application.Term_of_Loan_Years,
			Tertiary_Annual_Income: this.data.application.Tertiary_Annual_Income,
			Total_Ob: this.data.application.Total_Ob,
			Referral_Amount: this.data.application.Referral_Amount,
			LPP_Included: this.data.application.LPP_Included,
			Co_Applicant_LPP: this.data.application.Co_Applicant_LPP,
			Credit_Upgrader_included: this.data.application.Credit_Upgrader_included,
			CU_Fee: this.data.application.CU_Fee,
			Sch_Payment_Plus_CU_Fee: this.data.application.Sch_Payment_Plus_CU_Fee,
			Loan_Date: this.data.application.Loan_Date,
			Date_Ordered: this.data.application.Date_Ordered,
			Date_Received: this.data.application.Date_Received,
			Interest_APR1: this.data.application.Interest_APR1,
			Fee_Est: this.data.application.Fee_Est,
			Click_n_loan: this.data.application.Click_n_loan,
			Deferral: this.data.application.Deferral,
			Loan_Agreement_Created_by:
				this.data.application.Loan_Agreement_Created_by,
			NSF_Fee: this.data.application.NSF_Fee,
			Credit_Owl_Course: this.data.application.Credit_Owl_Course,
			Grand_Total_Credit_Owl_Fees:
				this.data.application.Grand_Total_Credit_Owl_Fees,
		};
	}

	closeModal() {
		this.dialogRef.close(false);
	}
}
